import axios from 'axios';

const Api = (url=process.env.VUE_APP_API_BASE_URL) => {
    return axios.create({
       baseURL: url,
    });
};
export default Api;